import React, { useContext } from 'react';
import { FavoriteContext } from './contexts/FavoriteContext'; // Make sure you have this context for favorites
import { Link } from 'react-router-dom';
import PageTitle from './includes/PageTitle';
import './css/Cart.css'; // Create a separate CSS file for favorites if needed

import { CartContext } from './contexts/CartContext';

function Favorites() {
  const { favorites, removeFavorite } = useContext(FavoriteContext);

  const { addToCart } = useContext(CartContext);
  const handleAddToCart = (product) => {
    const item = {
        id: product.id,
        name: product.name,
        price: product.price,
        images: product.images,
        quantity: 1,
        color: product.colors ? product.colors[0] : null,
        size: product.sizes ? product.sizes[0] : null,
    };
    addToCart(item);
};

  return (
    <>
      <PageTitle title="Favorites - ALMOSTINVISIBLE" />
      {favorites.length === 0 ? (
        <div className="d-flex align-content-center flex-column container justify-content-start" style={{margin: "30vh auto"}}>
          <div>
            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="7em" width="7em" xmlns="http://www.w3.org/2000/svg">
              <g>
                <path fill="none" d="M0 0h24v24H0z"></path>
                <path d="M12 2c5.523 0 10 4.477 10 10a9.958 9.958 0 0 1-1.065 4.496 1.977 1.977 0 0 0-.398-.775l-.123-.135L19 14.172l-1.414 1.414-.117.127a2 2 0 0 0 1.679 3.282A9.974 9.974 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2zm0 13c-1.38 0-2.63.56-3.534 1.463l-.166.174.945.86C10.035 17.182 10.982 17 12 17c.905 0 1.754.144 2.486.396l.269.1.945-.86A4.987 4.987 0 0 0 12 15zm-3.5-5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm7 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"></path>
              </g>
            </svg>
          </div>
          <div className="d-flex flex-column">
            <h1 className="unbounded" style={{fontSize: "40px"}}>
              Your Favorites List Is Currently Empty
            </h1>
            <div className="d-flex align-content-center ">
              <p className='nunito-2 fw-bold h4 mt-2'>
                Fill it up now
              </p>
              <Link to='/all-products' className='black-button mx-4'>
                Shop Now
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <div className="cart-container" style={{marginTop: "25vh"}}>
          <div className="container px-4">
            <div className="row gx-5">
              <div className="col-md-12">
                <h1 className='unbounded text-center'>Favorites</h1>
                <div className="cart-header">
                  <Link to="/all-products" className="continue-shopping fw-bold nunito-2 border-bottom-hover">
                    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 16 16" height="1.3em" width="1.3em" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 010 .708L5.707 8l5.647 5.646a.5.5 0 01-.708.708l-6-6a.5.5 0 010-.708l6-6a.5.5 0 01.708 0z" clipRule="evenodd"></path>
                    </svg>
                    Continue Shopping
                  </Link>
                  
                  <span className='nunito'>{favorites.length} item(s)</span>
                </div>
                <ul className="cart-items">
                    {favorites.map((item) => (
                        <li key={`${item.id}-${item.color}-${item.size}`} className="cart-item-wrapper">
                            <div className="cart-item">
                                <img src={item.images[0]} alt={item.name} className="cart-item-image" />
                                <div className="cart-item-details">
                                    <p className='nunito-sans fw-bold'>{item.name}</p>
                                </div>
                                <div className="cart-item-price">
                                    <button onClick={() => removeFavorite(item.id, item.color, item.size)} className="remove-item">
                                    <svg stroke="currentColor" fill="red" strokeWidth="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 5.5A.5.5 0 016 6v6a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zm2.5 0a.5.5 0 01.5.5v6a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zm3 .5a.5.5 0 00-1 0v6a.5.5 0 001 0V6z"></path><path fillRule="evenodd" d="M14.5 3a1 1 0 01-1 1H13v9a2 2 0 01-2 2H5a2 2 0 01-2-2V4h-.5a1 1 0 01-1-1V2a1 1 0 011-1H6a1 1 0 011-1h2a1 1 0 011 1h3.5a1 1 0 011 1v1zM4.118 4L4 4.059V13a1 1 0 001 1h6a1 1 0 001-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" clipRule="evenodd"></path></svg>
                                    </button>
                                    <p>₦{parseFloat(item.price).toFixed(2)}</p>
                                </div>
                            </div>
                            <div className="d-flex justify-content-around">
                                <button className="black-button d-flex align-content-center" onClick={() => handleAddToCart(item)}>
                                    <span className='unbounded' style={{ fontSize: "15px" }}>Add to bag &nbsp;</span>
                                    <svg
                                        stroke="currentColor"
                                        fill="currentColor"
                                        strokeWidth={0}
                                        viewBox="0 0 16 16"
                                        height="1.2em"
                                        width="1.2em"
                                        xmlns="http://www.w3.org/2000/svg"
                                        >
                                        <path
                                            fillRule="evenodd"
                                            d="M14 5H2v9a1 1 0 001 1h10a1 1 0 001-1V5zM1 4v10a2 2 0 002 2h10a2 2 0 002-2V4H1z"
                                            clipRule="evenodd"
                                        />
                                        <path d="M8 1.5A2.5 2.5 0 005.5 4h-1a3.5 3.5 0 117 0h-1A2.5 2.5 0 008 1.5z" />
                                        </svg>
                                </button>
                                <Link to={`/p/${item.id}`} className='black-button' style={{fontSize: "13px"}}>
                                    View Product
                                </Link>
                            </div>
                            
                        </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Favorites;
